import { render, staticRenderFns } from "./MetadataDrawerMain.vue?vue&type=template&id=997d5b3e&scoped=true"
import script from "./MetadataDrawerMain.vue?vue&type=script&lang=js"
export * from "./MetadataDrawerMain.vue?vue&type=script&lang=js"
import style0 from "./MetadataDrawerMain.vue?vue&type=style&index=0&id=997d5b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997d5b3e",
  null
  
)

export default component.exports